import { render, staticRenderFns } from "./NewDesignCurve.vue?vue&type=template&id=0a907933&"
import script from "./NewDesignCurve.vue?vue&type=script&lang=js&"
export * from "./NewDesignCurve.vue?vue&type=script&lang=js&"
import style0 from "./NewDesignCurve.vue?vue&type=style&index=0&id=0a907933&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports